(function (t) {
// sw
t.add("label_previous", "Kabla", "KnpPaginatorBundle", "sw");
t.add("label_next", "Ijayo", "KnpPaginatorBundle", "sw");
})(Translator);
